import * as React from "react";

import { cn } from "@/lib/utils";

type SectionHeaderProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  align?: "left" | "center";
};

export function SectionHeader({
  title,
  description,
  className,
  titleClassName,
  descriptionClassName,
  align = "left",
}: SectionHeaderProps) {
  const centered = align === "center";

  return (
    <div
      className={cn(
        "site-section-header",
        centered && "mx-auto text-center",
        className,
      )}
    >
      <h2 className={cn("site-h2", centered && "mx-auto", titleClassName)}>
        {title}
      </h2>
      {description ? (
        <p
          className={cn(
            "site-subtitle",
            centered && "mx-auto",
            descriptionClassName,
          )}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}
